"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const component_icon_1 = require("@patternplate/component-icon");
exports.StyledSearchField = styled_components_1.default.label `
  display: flex;
  align-items: center;
  height: 60px;
  padding: 10px 15px;
`;
exports.StyledIcon = styled_components_1.default(component_icon_1.Icon) `
  flex-grow: 0;
  flex-shrink: 0;
  fill: ${props => props.theme.colors.color};
`;
exports.StyledInput = styled_components_1.default.input `
  position: relative;
  z-index: 2;
  width: 100%;
  border: 0;
  border-radius: 0;
  background: transparent;
  font-size: 16px;
  color: ${props => props.theme.colors.color};
  padding: 0;
  appearance: none;
  border-radius: 0;
  border: none;
  :focus {
    outline: none;
  }
`;
exports.StyledInputContainer = styled_components_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 0;
  margin-left: 10px;
`;
exports.StyledInputSuggestion = styled_components_1.default(exports.StyledInput).attrs({ readOnly: true }) `
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  opacity: 0.3;
`;
//# sourceMappingURL=search-field.styles.js.map